import * as React from "react";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { FooterSubscribe } from "../FooterSubscribe/FooterSubscribe";
import {FooterForm} from "@src/stories/navigation/Footer/FooterForm/FooterForm";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import AnimatedLines from "@src/stories/client/AnimatedLines/AnimatedLines";
import {Button} from "@src/stories/elements/Button/Button";

export const Multicolumns = ({ id, globals, shop, settings, links, type }) => {
   const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

   const { footer_title, footer_title_style, footer_title_style_mobile } = settings;
  
  return (
    <div className={type}>
  
        <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'} footer-column gap-[64px]`}>
          <div className={`footer-text flex flex-col gap-[40px] lg:gap-[64px] z-10 basis-3/5`}>
            <h1 className={`${isMobile ? footer_title_style_mobile : footer_title_style}`}>{footer_title}</h1>
            <Button link={`/pages/services`} style="secondary" className={`lg:w-[452px]`} icon="right-arrow-alt" label="See MindArc Services" reverse={true} />
            <div className={`footer-links`}>
              {links.map((list_links, id) => {
                switch (list_links.type) {
                  case "list":
                    return (
                      <React.Fragment key={id}>
                        <div
                          className={`lg:w-[${list_links.settings.text_column_width}] ml-[${list_links.settings.margin_left_right_mobile}px] lg:ml-[${list_links.settings.margin_left_right_desktop}px]`}
                        >
                          <FooterLinks
                            id={id}
                            shop={shop}
                            globals={globals}
                            settings={settings}
                            list_links={list_links}
                            type={type}
                          />
                        </div>
                      </React.Fragment>
                    );
                  case "email_subscribe":
                    return (
                      <React.Fragment key={id}>
                        <div
                          className={`lg:w-[${list_links.settings.text_column_width}] lg:mr-[112px]`}
                        >
                          <FooterSubscribe
                            id={id}
                            shop={shop}
                            globals={globals}
                            settings={settings}
                            list_links={list_links}
                          />
                        </div>
                      </React.Fragment>
                    );
                }
              })}
            </div>
          </div>
          <div className={`footer-form basis-2/5 z-10`}>
              <FooterForm settings={settings} />
          </div>
        </div>
        <AnimatedLines 
            backgroundColor="transparent"
            lineColors={['#EDD5C9', '#899B30', '#D6CFF8']}
            lineCount={2}
            glowIntensity={10}   
            animationSpeed={0.2}
            lineThickness={1}
            curveAmplitude={360}
            verticalCurveAmplitude={360}
            verticalLineCount={2}
            showVerticalLines={true}
            globalOpacity={0.3}
          />
    </div>
  );
};
